document.addEventListener(
"DOMContentLoaded",
() => {

const btn =
document.getElementById(
"saveDesignBtn"
);

if(!btn) return;

btn.addEventListener(
"click",
async () => {

window.EMBStorage.save();

const design =
JSON.parse(
localStorage.getItem(
"embroideryDesign"
)
);

const designName =
document.getElementById("designName")
?.value
?.trim() || "";

if (!designName) {
  alert("Please enter a design name");
  return;
}
const previewArea =
document.querySelector(
"#embroideryPreview"
);
const designId =
Date.now().toString();

const blob =
await window.EMBThumbnail.generateBlob();

const previewUrl =
await window.EMBUpload.upload(
blob,
designId
);
console.log(
"THUMBNAIL BLOB:",
blob
);

console.log(
"THUMBNAIL SIZE:",
blob.size
);

console.log(
"UPLOAD URL:",
previewUrl
);

const result =
await window.embroiderySupabase
.from("embroidery_designs")
.insert([
{
design_name: designName,
design_data: design,
thumbnail_url: previewUrl
}
])
.select();

console.log(
"SAVED DESIGN:",
result
);

console.log(
"SAVED DESIGN:",
result
);

}
);

});